<template>
  <div class="l-row">
    <form-group :label="$t('category.label')">
      <multiselect
          v-model="newItem.from.category"
          :options="from.categories"
          selectLabel=""
          selectedLabel=""
          placeholder="Escolha"
      />
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="$t('category.label')" :columns="3">
      <multiselect
          v-model="categorySelect"
          :options="to.categories"
          selectLabel=""
          selectedLabel=""
          placeholder="Escolha"
      />
    </form-group>

    <form-group :label="$t('productTypes.label')" :columns="3" v-if="newItem.to.category !== null && showProductTypes">
      <multiselect
          v-model="newItem.to.productType"
          :options="to.productTypes"
          selectLabel=""
          selectedLabel=""
          placeholder="Escolha"
      />
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'
  import Multiselect from 'vue-multiselect'

  export default {
    data: () => ({
      from: {
        categories: []
      },
      to: {
        categories: [],
        productTypes: []
      },
      newItem: {
        from: {
          category: null
        },
        to: {
          category: null,
          productType: null
        }
      },
      items: [],
      categorySelect: null,
      alreadyExists: false,
      showProductTypes: false,
      loaderCategories: true,
      cloneCategories: null,
      loaderToCategories: true
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getCategories(this.preset.from.module.type, this.preset.from.module.identifier)
        .then(categories => {
          this.from.categories = categories
          this.loaderCategories = false
          this.hideItem()
          this.$emit('loading', this.loaderCategories || this.loaderToCategories)
        })
        .catch(() => notifier.error('Impossível carregar as categorias da Moovin.', 'Erro'))

      api.getCategories('marketplace', 'amazon')
        .then(categories => {
          for (let categorie of categories) {
            this.to.categories.push(categorie['name'])
          }
          this.loaderToCategories = false
          this.$emit('loading', this.loaderCategories || this.loaderToCategories)
        })
        .catch(() => notifier.error('Impossível carregar os categorias da Amazon.', 'Erro'))
    },
    methods: {
      hideItem () {
        if (!this.cloneCategories) {
          this.cloneCategories = cloneDeep(this.from.categories)
        }

        this.from.categories = cloneDeep(this.cloneCategories)

        for (let i in this.preset.items) {
          const item = this.preset.items[i]

          const index = this.from.categories.indexOf(item.from.category)
          if (index !== -1) {
            this.from.categories.splice(index, 1)
          }
        }
      },
      getProductTemplateProductTypes () {
        if (this.newItem.to.category === null) {
          return false
        }

        this.$emit('loading', true)

        this.newItem.to.productType = null

        api.getCategories('marketplace', 'amazon')
          .then(categories => {
            let amazonProductTypes = categories.find(categorie => categorie.name === this.newItem.to.category).productTypes
            for (let productType of amazonProductTypes) {
              this.to.productTypes.push(productType.name)
            }
            this.$emit('loading', false)
          })
          .catch(() => notifier.error('Impossível carregar os tipos de produto da Amazon.', 'Erro'))
      },
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            category: this.newItem.from.category
          },
          to: {
            category: this.newItem.to.category,
            productType: this.newItem.to.productType
          }
        }

        const itemExist = this.preset.items.filter(
          itemPreset => (
            itemPreset.from.category === item.from.category &&
            itemPreset.to.category === item.to.category && itemPreset.to.productType === item.to.productType
          )
        )

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return {
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'item': this.newItem
        }
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      }
    },
    watch: {
      'to.productTypes' (value) {
        this.showProductTypes = value.length > 0
      },
      'preset.items' (value) {
        this.items = value

        this.hideItem()
      },
      'newItem.from.category' () {
        this.emitEnabledAdd()
      },
      'categorySelect' (value) {
        if (value === null) {
          return
        }

        this.newItem.to.category = this.categorySelect

        this.getProductTemplateProductTypes()
        this.emitEnabledAdd()
      },
      'newItem.to.productType' () {
        this.emitEnabledAdd()
      },
      'newItem.to.category' (value) {
        if (value === null) {
          this.categorySelect = null
        }
      }
    },
    components: {
      Panel,
      FormGroup,
      Multiselect
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// CategorizationAddItem.vue?39f98156